<template>
  <path pid="0" d="M13 24A11 11 0 102 13a11 11 0 0011 11zm0-20a9 9 0 11-9 9 9 9 0 019-9z"/><path pid="1" d="M11.55 17.83l6-4a1 1 0 000-1.66l-6-4A1 1 0 0010 9v8a1 1 0 001.55.83zm.45-7L15.2 13 12 15.13z"/>
</template>
